import { NgModule } from '@angular/core';
import { ShopboxCommonModule } from '@shared/common/common.module';
import { ShopboxMaterialModule } from '../shopbox-material/shopbox-material.module';
import { RouterModule } from '@angular/router';
import { ItemComponent, ListComponent } from './components';

@NgModule({
    imports: [
        RouterModule,
        ShopboxCommonModule,
        ShopboxMaterialModule,
        ItemComponent, ListComponent
    ],
    exports: [
        ListComponent
    ]
})
export class NavModule { }
